// Modelo do catálogo de cartas na web + filtro (lógica pura, testada). Usado pela galeria do site
// e, a partir do W5, pela página Cartas do backoffice. Os dados vêm do jogo (godot/data) — nunca se inventam aqui.
import type { Aspect, Rarity } from "@ecliptica/tokens";

export const ASPECTS = ["sol", "lua", "eclipse"] as const satisfies readonly Aspect[];
export const CARD_TYPES = ["unit", "spell", "seal"] as const;
export const RARITIES = ["C", "I", "R", "M"] as const satisfies readonly Rarity[];
export type CardType = (typeof CARD_TYPES)[number];
export type CatalogLang = "pt" | "en";

export type CardText = { name: string; tribe: string; text: string; flavor: string };

export type CatalogCard = {
  id: string;
  num: number;
  type: CardType;
  aspect: Aspect;
  rarity: Rarity;
  cost: number | null;
  atk: number | null;
  hp: number | null;
  ed: string;
  pt: CardText;
  en: CardText;
};

export type CatalogEdition = { code: string; kind: string; size: number; pt: string; en: string };
export type Catalog = { editions: CatalogEdition[]; cards: CatalogCard[] };

export type CardFilter = { ed: string; aspect: string; type: string; rarity: string; q: string };
export const EMPTY_FILTER: CardFilter = { ed: "", aspect: "", type: "", rarity: "", q: "" };

/** Normaliza para pesquisa: minúsculas e sem acentos ("Vésper" encontra-se com "vesper"). */
export function fold(s: string): string {
  return s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
}

export function filterCards(cards: CatalogCard[], f: CardFilter, lang: CatalogLang): CatalogCard[] {
  const q = fold(f.q.trim());
  return cards.filter((c) => {
    if (f.ed && c.ed !== f.ed) return false;
    if (f.aspect && c.aspect !== f.aspect) return false;
    if (f.type && c.type !== f.type) return false;
    if (f.rarity && c.rarity !== f.rarity) return false;
    if (q) {
      const t = c[lang];
      if (!fold(`${t.name} ${t.text} ${t.tribe} ${c.id}`).includes(q)) return false;
    }
    return true;
  });
}
